import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SolutionSevices from "./SolutionSevices";

const initialState = {
    solutions: [],
    solution: [],
    isSuccess: false,
    isError: false,
    isLoading: false,
    errors: [],
};

export const GetAllSolutions = createAsyncThunk(
    "solutions/index",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await SolutionSevices.GetAllSolutions(data,token);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);

export const SearchOnSolutions = createAsyncThunk(
    "solution/byuser",
    async (data, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await SolutionSevices.SearchOnSolutions(data, token);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);

export const GetSingleSolutions = createAsyncThunk(
    "solutions/show",
    async (id, thunkAPI) => {
        let { rejectWithValue, getState } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await SolutionSevices.GetSingleSolutions(id, token);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);
const SolutionsSlice = createSlice({
    name: "solutions",
    initialState,
    reducers: {
        solutionReset: (state) => {
            state.isSuccess = false;
            state.isError = false;
            state.isLoading = false;
            state.errors = [];
        },
    },
    extraReducers: {
        // Get All Solutions
        [GetAllSolutions.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllSolutions.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.solutions = action.payload;
        },
        [GetAllSolutions.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Get User Solutions
        [SearchOnSolutions.pending]: (state) => {
            state.isLoading = true;
        },
        [SearchOnSolutions.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.solutions = action.payload;
        },
        [SearchOnSolutions.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Get Single Solutions
        [GetSingleSolutions.pending]: (state) => {
            state.isLoading = true;
        },
        [GetSingleSolutions.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.solution = action.payload;
        },
        [GetSingleSolutions.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },
    },
});

export const { solutionReset } = SolutionsSlice.actions;
export default SolutionsSlice.reducer;
